import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom_Simple.js';
import { Modal } from "react-bootstrap";
import PN from "persian-number";


const InsertInventoryCountingIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const [ShowPriceModal, setShowPriceModal] = React.useState(false);
    const [ItemList, setItemList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [InventoryCountingState, setInventoryCountingState] = useState(localStorage.getItem("InventoryCountingState"));
    const [InventoryCountingId, setInventoryCountingId] = useState(localStorage.getItem("InventoryCountingId"));
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [StoreRoom, setStoreRoom] = useState("");
    const [Title, setTitle] = useState('');
    const [Number, setNumber] = useState('');
    const [CountingDate, setCountingDate] = useState(moment(new Date()));
    const [CountingDateReadOnly, setCountingDateReadOnly] = useState(moment(new Date()).format('jYYYY/jMM/jDD'));
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Methods

    const CountingDate_Change = (e) => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setCountingDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const GetById = (id) => {
        trackPromise(
            fetch(General.ApiRoute() + '/InventoryCounting/GetById', {
                method: 'POST',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setCountingDate(moment(result.countingDate, 'jYYYY/jMM/jDD'))
                    setCountingDateReadOnly(result.countingDate)
                    setTitle(result.title)
                    setStoreRoomId(result.storeRoomId)
                    setStoreRoom(result.storeRoom)
                    setNumber(result.number)
                    GetItem(id)

                })
        )
    }


    const Save = () => {


        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }

        if (StoreRoomId == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب انبار اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": InventoryCountingId,
                "Title": Title,
                "StoreRoomId": StoreRoomId,
                "CountingDate": moment(CountingDate.format()).format('jYYYY/jMM/jDD'),
                "FiscalYearId": FiscalYearId,
            },
            url: General.ApiRoute() + "/InventoryCounting/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        GetItem(result.data.Split("|")[1]);
                        setInventoryCountingId(result.data.Split("|")[1])
                        localStorage.setItem("InventoryCountingId", result.data.Split("|")[1])

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const UpdateState = (state, createReciept = false) => {

        // console.dir(state)

        // console.dir(state == 4 && ItemList.findIndex(x => x.MaxPrice == 0 && x.CountingPrice == 0) != -1)


        if ((state == 4 && ItemList.findIndex(x => x.MaxPrice == 0 && x.CountingPrice == 0) != -1) && !createReciept) {
            setShowPriceModal(true);
        }
        else {
            var RequestOptions = {
                data: {
                    "Id": InventoryCountingId,
                    "FiscalYearId": FiscalYearId,
                    "State": state,
                    "StoreRoom": StoreRoom
                },
                url: General.ApiRoute() + "/InventoryCounting/UpdateState",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }

            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            localStorage.setItem("InventoryCountingState", state)
                            setInventoryCountingState(state);
                            setShowPriceModal(false);


                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        }



    }


    const GetItem = (inventoryCountingId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/InventoryCounting/SearchForInsert', {
                method: 'Post',
                headers: {
                    'ApiKey': General.APIKey(),
                    'FiscalYearId': FiscalYearId,
                    'State': InventoryCountingState,
                    'InventoryCountingId': inventoryCountingId,

                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    console.dir(result)
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            SRIId: result[i].sriId,
                            PhysicalCount: result[i].physicalCount,
                            SaleCount: result[i].saleCount,
                            Price: result[i].price,
                            MaxPrice: result[i].maxPrice,
                            StateCounting1: result[i].stateCounting1,
                            StateCounting2: result[i].stateCounting2,
                            StateCounting3: result[i].stateCounting3,
                            Product: result[i].product,
                            Count1: result[i].count1,
                            Count2: result[i].count2,
                            Count3: result[i].count3,
                            StoreRoom: result[i].storeRoom,
                            ProductId: result[i].productId,
                            ProductId: result[i].productId,
                            DiffCount: result[i].diffCount,
                            CountingPrice: result[i].countingPrice,
                        })
                    }
                    setItemList(tmp)
                })
        )
    }


    const Change_Item = (row, value, state) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.Row == row);
        console.dir(value)
        if (index != -1) {
            if (state == 0) {
                temp[index].Count1 = value;
                temp[index].DiffCount = value - temp[index].PhysicalCount

            }
            if (state == 1) {
                temp[index].Count2 = value;
                temp[index].DiffCount = value - temp[index].PhysicalCount

            }
            if (state == 2) {
                temp[index].Count3 = value;
                temp[index].DiffCount = value - temp[index].PhysicalCount

            }
            if (state == 3) {
                temp[index].CountingPrice = value.replaceAll(',', '') * 1;


            }

        }
        console.dir(temp)
        setItemList(temp);
    }



    const Upsert = (row, value, state) => {
        if (value == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تعداد اجباری می باشد")), 'topCenter')
            return;
        }
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.Row == row);
        console.dir(row)
        console.dir(value)
        console.dir(value.target.value)
        if (index != -1) {
            var RequestOptions = {
                data: {
                    "Id": temp[index].Id,
                    "ProductId": temp[index].ProductId,
                    "Count1": state == 0 ? value.target.value : temp[index].Count1,
                    "Count2": state == 1 ? value.target.value : temp[index].Count2,
                    "Count3": state == 2 ? value.target.value : temp[index].Count3,
                    "PhysicalCount": temp[index].PhysicalCount,
                    "SRIId": temp[index].SRIId,
                    "InventoryCountingId": InventoryCountingId,
                    "State": state,
                },
                url: General.ApiRoute() + "/InventoryCounting/SaveItem",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                            if (state == 0) {
                                temp[index].Count1 = value.target.value
                                temp[index].DiffCount = value.target.value - temp[index].PhysicalCount
                                temp[index].StateCounting1 = 1
                                temp[index].Id = result.data.split("|")[1]
                            }

                            else if (state == 1) {
                                temp[index].Count2 = value.target.value
                                temp[index].DiffCount = value.target.value - temp[index].PhysicalCount
                                temp[index].StateCounting2 = 1
                            }
                            else if (state == 3) {
                                temp[index].Count3 = value.target.value
                                temp[index].DiffCount = value.target.value - temp[index].PhysicalCount
                                temp[index].StateCounting3 = 1
                            }
                            setItemList(temp);

                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )
        }
    }

    const UpdatePrice = (row, value) => {
        if (value == "" || value == "0") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن قیمت اجباری می باشد")), 'topCenter')
            return;
        }
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.Row == row);

        if (index != -1) {
            var RequestOptions = {
                data: {
                    "Id": temp[index].Id,
                    "CountingPrice": value.target.value.replaceAll(',', '') * 1,
                    "Product": temp[index].Product,
                    "StoreRoom": StoreRoom
                },
                url: General.ApiRoute() + "/InventoryCounting/Update_ItemPrice",
                method: "post",
                withCredentials: true,
                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            temp[index].CountingPrice = value.target.value.replaceAll(',', '') * 1;
                            setItemList(temp);
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )
        }
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 41);
        myHeaders.append("Operation", localStorage.getItem("InventoryCountingId") == General.GuidEmpty() ? 0 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("InventoryCountingId") != General.GuidEmpty())
                            GetById(localStorage.getItem("InventoryCountingId"));

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = " ثبت اطلاعات انبار گردانی";
    }, [])
    //#endregion







    return (

        <Layout title='ثبت اطلاعات انبار گردانی'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="blue" size="xs"
                                    disabled={
                                        (InventoryCountingState == '0' && ItemList.length != 0 && ItemList.findIndex(x => x.StateCounting1 == 1) != -1) ||
                                            (InventoryCountingState == 1 && ItemList.length != 0 && ItemList.findIndex(x => x.StateCounting2 == 0) == -1) ||
                                            (InventoryCountingState == 2 && ItemList.length != 0 && ItemList.findIndex(x => x.StateCounting3 == 0 && x.Count1 - x.Count2 != 0) == -1) ||
                                            InventoryCountingState == 3 ?
                                            false
                                            : true
                                    }


                                    className="m-1" onClick={() => UpdateState(InventoryCountingState == '0' ? 1 : InventoryCountingState == '1' ? 2 : InventoryCountingState == '2' ? 3 : 4)}>
                                    {InventoryCountingState == '0' ?
                                        <>اتمام مرحله اول شمارش</> :
                                        InventoryCountingState == 1 ?
                                            <>اتمام مرحله دوم شمارش</> :

                                            InventoryCountingState == 2 ?
                                                <>اتمام مرحله سوم شمارش</>
                                                :
                                                <>ثبت و صدور حواله و رسید انبار</>


                                    }
                                </rsuite.Button>

                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={() => Save()}>
                                    {InventoryCountingState == '0' && (ItemList.length == 0 || ItemList.findIndex(x => x.StateCounting1 != 0) == -1) ?
                                        <>ثبت</> :
                                        <>ویرایش</>
                                    }
                                </rsuite.Button>

                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("InventoryCountingId"), navigate("/InventoryCounting"))}>  بازگشت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row >
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>شماره </label>
                            <rsuite.Input disabled value={Number} />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className={InventoryCountingState == '0' && (ItemList.length == 0 || ItemList.findIndex(x => x.StateCounting1 != 0) == -1) ? 'p-1' : 'hide'}>
                            <label> تاریخ </label>
                            <DatePicker className="rs-input " isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={CountingDate} onChange={CountingDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className={InventoryCountingState == '0' && (ItemList.length == 0 || ItemList.findIndex(x => x.StateCounting1 != 0) == -1) ? 'hide' : 'p-1'}>
                            <label> تاریخ </label>
                            <rsuite.Input disabled value={CountingDateReadOnly} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className={InventoryCountingState == '0' && (ItemList.length == 0 || ItemList.findIndex(x => x.StateCounting1 != 0) == -1) ? 'p-1' : 'hide'}>
                            <label>انبار </label>
                            <Drp_StoreRoom className='rs-input' value={StoreRoomId} onChange={(e) => setStoreRoomId(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className={InventoryCountingState == '0' && (ItemList.length == 0 || ItemList.findIndex(x => x.StateCounting1 != 0) == -1) ? 'hide' : 'p-1'}>
                            <label>انبار </label>
                            <rsuite.Input disabled value={StoreRoom} />
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> توضیحات </label>
                            <rsuite.Input value={Title} onChange={(e) => (setTitle(e))} />
                        </rsuite.Col>


                    </rsuite.Row>

                    <hr />
                    <div className={InventoryCountingId == General.GuidEmpty() ? "hide" : "h-90 p-1"}>
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={520}
                                    data={ItemList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.SRIId == General.GuidEmpty() ? 'text-primary' : ""}>
                                                        <BiIcon.BiCheckCircle className={rowData.Count1 - rowData.Count2 == 0 && InventoryCountingState > 1 ? 'text-success' : 'hide'} />

                                                        {rowData.Row}</text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>محصول</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.SRIId == General.GuidEmpty() ? 'text-primary' : ""}>
                                                        {rowData.Product}
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText sortable resizable>
                                        <rsuite.Table.HeaderCell> اخرین قیمت خرید</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.SRIId == General.GuidEmpty() ? 'text-primary' : ""}>
                                                        {PN.sliceNumber(rowData.MaxPrice)}
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column sortable resizable>
                                        <rsuite.Table.HeaderCell>تعداد فیزیکی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.SRIId == General.GuidEmpty() ? 'text-primary' : ""}>
                                                        {rowData.PhysicalCount}
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column sortable resizable>
                                        <rsuite.Table.HeaderCell>تعداد قابل فروش</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <text className={rowData.SRIId == General.GuidEmpty() ? 'text-primary' : ""}>
                                                        {rowData.SaleCount}
                                                    </text>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column sortable resizable>
                                        <rsuite.Table.HeaderCell>شمارش 1  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.StateCounting1 == 0 && InventoryCountingState == 0 ?
                                                        <rsuite.Input className='rs-input' value={rowData.Count1}
                                                            onChange={e => { Change_Item?.(rowData.Row, e, 0); }}
                                                            onBlur={e => { Upsert?.(rowData.Row, e, 0); }}
                                                        ></rsuite.Input>
                                                        : rowData.StateCounting1 != 0 && InventoryCountingState == 0 ?
                                                            <rsuite.Input className='rs-input' style={{
                                                                backgroundColor: "#dfeee7ff",
                                                                border: "1px solid #94a79eff"
                                                            }}
                                                                value={rowData.Count1}
                                                                onChange={e => { Change_Item?.(rowData.Row, e, 0); }}
                                                                onBlur={e => { Upsert?.(rowData.Row, e, 0); }}
                                                            ></rsuite.Input>
                                                            :
                                                            <text className={rowData.SRIId != General.GuidEmpty() ? 'text-muted ' : ""}  >{rowData.Count1}</text>
                                                    }

                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column sortable resizable>
                                        <rsuite.Table.HeaderCell>شمارش 2  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.StateCounting2 == 0 && InventoryCountingState == 1 ?
                                                        <rsuite.Input className='rs-input' value={rowData.Count2}
                                                            onChange={e => { Change_Item?.(rowData.Row, e, 1); }}
                                                            onBlur={e => { Upsert?.(rowData.Row, e, 1); }}
                                                        ></rsuite.Input>
                                                        : rowData.StateCounting2 != 0 && InventoryCountingState == 1 ?
                                                            <rsuite.Input className='rs-input' style={{
                                                                backgroundColor: "#dfeee7ff",
                                                                border: "1px solid #94a79eff"
                                                            }}
                                                                value={rowData.Count2}
                                                                onChange={e => { Change_Item?.(rowData.Row, e, 1); }}
                                                                onBlur={e => { Upsert?.(rowData.Row, e, 1); }}
                                                            ></rsuite.Input>
                                                            :
                                                            <text className={rowData.SRIId != General.GuidEmpty() ? 'text-muted ' : ""}  >{rowData.Count2}</text>
                                                    }

                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column sortable resizable>
                                        <rsuite.Table.HeaderCell>شمارش 3  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.StateCounting3 == 0 && InventoryCountingState == 2 ?
                                                        <rsuite.Input className='rs-input' value={rowData.Count3}
                                                            disabled={rowData.Count1 - rowData.Count2 == 0 ? true : false}
                                                            onChange={e => { Change_Item?.(rowData.Row, e, 2); }}
                                                            onBlur={e => { Upsert?.(rowData.Row, e, 2); }}
                                                        ></rsuite.Input>
                                                        : rowData.StateCounting3 != 0 && InventoryCountingState == 2 ?
                                                            <rsuite.Input className='rs-input' style={{
                                                                backgroundColor: "#dfeee7ff",
                                                                border: "1px solid #94a79eff"
                                                            }}
                                                                value={rowData.Count3}
                                                                onChange={e => { Change_Item?.(rowData.Row, e, 2); }}
                                                                onBlur={e => { Upsert?.(rowData.Row, e, 2); }}
                                                            ></rsuite.Input>
                                                            :
                                                            <text className={rowData.SRIId != General.GuidEmpty() ? 'text-muted ' : ""}  >{rowData.Count3}</text>
                                                    }

                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    {InventoryCountingState != 0 ?
                                        <>
                                            <rsuite.Table.Column fullText sortable resizable>
                                                <rsuite.Table.HeaderCell>اضافات انبار </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.DiffCount > 0 ?
                                                                <text className='text-success ' >{rowData.DiffCount}</text>
                                                                :
                                                                <text>-</text>

                                                            }
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column fullText sortable resizable>
                                                <rsuite.Table.HeaderCell>کسورات انبار </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>

                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.DiffCount < 0 ?
                                                                <text className='text-danger' >{rowData.DiffCount * (-1)}</text>
                                                                :
                                                                <text>-</text>

                                                            }
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </>
                                        :
                                        <>
                                        </>
                                    }

                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>
                    <div className={InventoryCountingId != General.GuidEmpty() ? "hide" : "alert alert-warning"}>
                        ابتدا ثبت اطلاعات اولبه انبار و انبارگردانی را انجام دهید
                    </div>
                </rsuite.Panel >
            </div >



            <Modal show={ShowPriceModal} className='bg-light' backdrop="static" scrollable keyboard={false} onHide={() => setShowPriceModal(false)} fullscreen={true} >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>ویرایش آخرین قیمت خرید  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Panel className="bg-white mt-2">
                                    <rsuite.Table
                                        autoHeight="true"
                                        data={ItemList.filter(x => x.MaxPrice == 0 && x.DiffCount > 0)}
                                        loading={loading}
                                    >
                                        <rsuite.Table.Column className="w-10p" align="center" fixed>
                                            <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell dataKey='Row' />
                                        </rsuite.Table.Column>


                                        <rsuite.Table.Column flexGrow={3} fullText resizable>
                                            <rsuite.Table.HeaderCell>محصول</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.Product}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>



                                        <rsuite.Table.Column flexGrow={1}>
                                            <rsuite.Table.HeaderCell>تعداد فیزیکی</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        <text className={rowData.SRIId != General.GuidEmpty() ? 'text-muted ' : ""}  >{rowData.PhysicalCount}</text>
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={1}>
                                            <rsuite.Table.HeaderCell>تعداد قابل فروش</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        <text className={rowData.SRIId != General.GuidEmpty() ? 'text-muted ' : ""} >{rowData.SaleCount}</text>
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>


                                        <rsuite.Table.Column flexGrow={1} >
                                            <rsuite.Table.HeaderCell>اضافات انبار </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.DiffCount > 0 ?
                                                            <text className='text-success ' >{rowData.DiffCount}</text>
                                                            :
                                                            <text>-</text>

                                                        }
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={1} >
                                            <rsuite.Table.HeaderCell> اخرین قیمت خرید واحد (ریال)</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>

                                                        <rsuite.Input className='rs-input' value={PN.sliceNumber(rowData.CountingPrice)}
                                                            onChange={e => { Change_Item?.(rowData.Row, e, 3); }}
                                                            onBlur={e => { UpdatePrice?.(rowData.Row, e); }}
                                                        ></rsuite.Input>


                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>


                                    </rsuite.Table>

                                </rsuite.Panel>
                            </rsuite.Col>
                        </rsuite.Row>



                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" disabled={ItemList.findIndex(x => x.MaxPrice == 0 && x.CountingPrice == 0 && x.DiffCount > 0) == -1 ? false : true} onClick={() => UpdateState(4, true)}>
                        صدور رسید / حواله ابتدای دوره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowPriceModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>


        </Layout >




    )
}

export default InsertInventoryCountingIndex;